import { CONFIG } from 'app/core/config';
import { ModelStatus } from '../model-status';
import { ViewModel } from '../view-model';

export class RunnableLookupBriefInfo implements ViewModel {
  friendlyTypeNameSingular: string = 'RunnableLookupBriefInfo';
  apiRoute: string = CONFIG.apiRoutes.runnableLookupsBriefInfo;

  lookupId: string;
  identifier: string;
  label: string;
  description: string;
  version = 0;
  status: ModelStatus = ModelStatus.Draft;
  createdClientSide: boolean;
  createdBy: string;
  creationDate: string;
  lastModifiedBy: string;
  lastModifiedDate: string;

  json() {
    return this;
  }
  loadFromJson(data: any) {
    this.lookupId = data.lookupId;
    this.identifier = data.identifier;
    this.label = data.label;
    this.description = data.description;
    this.version = data.version;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.status = data.status;
    this.createdClientSide = data.createdClientSide;
  }

}